module.exports = __webpack_public_path__ + "static/media/circle3.0ddeba10.svg";